import * as t from '~/messages'

interface NoResults {
  title: string
  suggestions: {
    title: string
    items: string[]
  }
  bottomText: string
}

export const useNoHallResults = (): NoResults => {
  return {
    title: t['w.module.no-results.hall.title'](),
    suggestions: {
      title: t['w.module.no-results.hall.suggestions.title'](),
      items: [
        t['w.module.no-results.hall.suggestions.items.try-more-generic-terms'](),
        t['w.module.no-results.hall.suggestions.items.try-various-keywords'](),
        t['w.module.no-results.hall.suggestions.items.ensure-no-typos'](),
      ],
    },
    bottomText: t['w.module.no-results.hall.bottom-text'](),
  }
}

export const useNoSearchResults = (): NoResults => {
  return {
    title: t['w.module.no-results.search.title'](),
    suggestions: {
      title: t['w.module.no-results.search.suggestions.title'](),
      items: [
        t['w.module.no-results.search.suggestions.items.try-more-generic-terms'](),
        t['w.module.no-results.search.suggestions.items.try-various-keywords'](),
        t['w.module.no-results.search.suggestions.items.ensure-no-typos'](),
      ],
    },
    bottomText: t['w.module.no-results.search.bottom-text'](),
  }
}
